import React, { useState } from "react";
import { Image } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/TopBar";
import "./index.css";
import {
  Form,
  Input,
  Select,
  Space,
  Tooltip,
  Typography,
  DatePicker,
  TimePicker,
  Button,
  message,
} from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import { createWellness } from "../../api/Schedule/createWellness";

export default function Index() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const today = moment(); // Today's date
  const [selectedMode, setSelectedMode] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  const onChangeDateStart = (values, dateString) => {
    //let date = moment(values).toISOString();

    let date = moment(dateString, "YYYY-MM-DD hh:mm:ss A").format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    setStartTime(date);
    console.log("dateString===>", date);
  };
  const onChangeDateEnd = (values, dateString) => {
    let date = moment(dateString, "YYYY-MM-DD hh:mm:ss A").format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    setEndTime(date);
  };
  const onFinish = (values) => {
    let userData;
    if (values.eventType === "VIRTUAL") {
      userData = JSON.stringify({
        organisationId: localStorage.getItem("organisationId"),
        title: values.title,
        eventType: values.eventType,
        meetingLink: values.meeting_link,
        startTime: startTime,
        endTime: endTime,
        type: "HEALTH_CAMPUS",
        active: true,
      });
    } else {
      userData = JSON.stringify({
        organisationId: localStorage.getItem("organisationId"),
        title: values.title,
        eventType: values.eventType,
        venue: values.venue,
        startTime: startTime,
        endTime: endTime,
        type: "HEALTH_CAMPUS",
        active: true,
      });
    }
    dispatch(createWellness(userData)).then((res) => {
      if (res.payload.status === "success") {
        message.success("Health Campus Session Created");
        form.resetFields();
      } else {
        message.success("Something went wrong");
      }
    });
  };
  const disabledDate = (current) => {
    return current.isBefore(today, "day");
  };
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />
      <div className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"}`}>
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          <div className="healthcamp-form bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm p-[24px] font-poppins" style={{ minHeight: "450px" }}>
            <Form
              form={form}
              name="complex-form"
              layout="vertical"
              onFinish={onFinish}
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
            >
              <Form.Item
                style={{
                  marginBottom: 0,
                }}
              >
                <Form.Item
                  label="Title"
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "Title is required",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50% - 8px)",
                  }}
                >
                  <Input
                    placeholder={"Enter Title"}
                    className="profile_input"
                  />
                </Form.Item>
                <Form.Item
                  label="Event Type"
                  name="eventType"
                  rules={[
                    {
                      required: true,
                      message: "Event Type is required",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50% - 8px)",
                    margin: "0 8px",
                  }}
                >
                  <Select
                    placeholder={"Select Event Type"}
                    style={{
                      width: "100%",
                    }}
                    onChange={(v) => {
                      setSelectedMode(v);
                    }}
                    options={[
                      {
                        label: "Virtual",
                        value: "VIRTUAL",
                      },
                      {
                        label: "On Campus",
                        value: "ON_CAMPUS",
                      },
                    ]}
                    className="profile_input"
                  />
                </Form.Item>
              </Form.Item>
              <Form.Item
                style={{
                  marginBottom: 0,
                }}
              >
                <Form.Item
                  label="Start Date & Time"
                  name="start_date"
                  rules={[
                    {
                      required: true,
                      message: "Start date & time is required",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50% - 8px)",
                  }}
                >
                  <DatePicker
                    showTime={{ use12Hours: true }}
                    onChange={onChangeDateStart}
                    style={{ width: "100%" }}
                    disabledDate={disabledDate}
                    className="profile_input"
                  />
                </Form.Item>
                <Form.Item
                  label="End Date & Time"
                  name="end_date"
                  rules={[
                    {
                      required: true,
                      message: "End date time is required",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50% - 8px)",
                    margin: "0 8px",
                  }}
                >
                  <DatePicker
                    showTime={{ use12Hours: true }}
                    onChange={onChangeDateEnd}
                    style={{ width: "100%" }}
                    disabledDate={disabledDate}
                    className="profile_input"
                  />
                </Form.Item>
              </Form.Item>
              <Form.Item
                style={{
                  marginBottom: 0,
                }}
              >
                {selectedMode === "VIRTUAL" ? (
                  <Form.Item
                    label="Meeting Link"
                    name="meeting_link"
                    rules={[
                      {
                        required: true,
                        message: "Meeting Link is required",
                      },
                    ]}
                    style={{
                      display: "inline-block",
                      width: "calc(50% - 8px)",
                    }}
                  >
                    <Input
                      placeholder={"Enter Meeting Link"}
                      className="profile_input"
                    />
                  </Form.Item>
                ) : (
                  <Form.Item
                    label="Venue"
                    name="venue"
                    rules={[
                      {
                        required: true,
                        message: "Venue is required",
                      },
                    ]}
                    style={{
                      display: "inline-block",
                      width: "calc(50% - 8px)",
                    }}
                  >
                    <Input placeholder={"Enter Venue"} />
                  </Form.Item>
                )}
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType={"submit"}
                  className="submit-btn btn-gradient border-0 rounded-xl font-poppins font-semibold text-[13px]"
                  style={{ width: "30%", height: "40px" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
